module.exports = __webpack_public_path__ + "media/images/flags/NC-4e93ef2eaf81045085226a34caf087ef.svg";